import { render, staticRenderFns } from "./SiteSwitcher.vue?vue&type=template&id=a72c3210&scoped=true&"
import script from "./SiteSwitcher.vue?vue&type=script&lang=js&"
export * from "./SiteSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SiteSwitcher.vue?vue&type=style&index=0&id=a72c3210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72c3210",
  null
  
)

export default component.exports